/* eslint-disable no-useless-escape */
import {
  fetch,
  getSubmissionHistory,
  callTransition,
  getSubstances,
  getCustomBlends,
  getSubmissions,
  getSubmission,
  getSubmissionFiles,
  deleteSubmission,
  deleteSubmissionFile,
  getPeriods,
  getObligations,
  createSubmission,
  getParties,
  getNonParties,
  getPartyRatifications,
  getCurrentUser,
  updateCurrentUser,
  uploadFile,
  getSubmissionDefaultValues,
  getSubmissionStates,
  getTransitions,
  getSubmissionFormats,
  getControlledGroups,
  getApprovedExemptionsList,
  getReports,
  getReportingChannels,
  getEmailTemplates,
  getCriticalUseCategoryList
} from '@/components/common/services/api'

import {
  getLevel2PropertyValue,
  getMessage,
  escapeHTML
} from '@/components/common/services/utilsService.js'

import { getLabels } from '@/components/art7/dataDefinitions/labels'

import router from '@/router'

const actions = {
  openConfirmModal({ commit }, { title, description, $gettext }) {
    return new Promise(resolve => {
      if (!title) {
        title = $gettext('Please confirm')
      }
      commit('setConfirmModal', {
        title,
        description,
        isVisible: true,
        okCallback: () => {
          commit('resetConfirmModal')
          resolve(true)
        },
        cancelCallback: () => {
          commit('resetConfirmModal')
          resolve(false)
        },
        hideCallBack: (event) => {
          if (event.trigger === 'esc') {
            commit('resetConfirmModal')
            resolve(false)
          }
        }
      })
    })
  },
  async addSubmission({ state, getters, dispatch }, { submission, $gettext }) {
    const duplicatesAll = getters.getDuplicateSubmission(submission)
    const duplicatesByCurrentUser = (
      duplicatesAll
      && duplicatesAll.length ? duplicatesAll.filter(x => x.filled_by_secretariat === state.currentUser.is_secretariat) : []
    )
    if (duplicatesAll.length >= 2 || duplicatesByCurrentUser.length) {
      await dispatch('setAlert', {
        $gettext,
        message: { __all__: [$gettext('Unable to add submission. Another submission for this obligation/year already exists. Please resume work on the existing one.')] },
        variant: 'danger'
      })
      // TODO: should this be a thing ?
      // else if(!isReportingOpen) {
      //     context.dispatch('setAlert', { message: 'Reporting is not open for the selected period', variant: 'danger' })
      // }
    }

    try {
      const response = await createSubmission(submission)
      await dispatch('setAlert', {
        $gettext,
        message: { __all__: [$gettext('Submission added successfully.')] },
        variant: 'success'
      })
      await dispatch('getCurrentSubmissions')
      return response.data
    } catch (error) {
      await dispatch('setAlert', {
        $gettext,
        message: { __all__: [$gettext('Unable to add submission.')] },
        variant: 'danger'
      })
      throw error
    }
  },

  prefillComments(context, data) {
    Object.keys(context.state.form.tabs)
      .filter(tab => context.state.form.tabs[tab].comments)
      .forEach(tab => context.commit('addComment', { data, tab }))
  },

  async getCurrentSubmissions(context) {
    const response = await getSubmissions(context.state.dashboard.table)
    await context.commit('setDashboardSubmissions', response.data)
    await context.dispatch('getMyCurrentSubmissions')
  },

  getUnsavedTabs(context) {
    const tabsWithData = []
    Object.values(context.state.form.tabs).forEach((tab) => {
      [false, 'edited'].includes(tab.status) && tabsWithData.push(tab.title)
    })
    return tabsWithData.length
  },
  // id = id of the component that triggered the save
  async confirmSaveDone(context, id) {
    const unsaved = await context.dispatch('getUnsavedTabs')
    if (!unsaved) {
      context.commit('saveSuccess', id)
    }
  },

  saveCallback(context, { actionToDispatch, data }) {
    context.dispatch(actionToDispatch, data)
  },

  async triggerSave(context, data) {
    if (data) {
      context.commit('setActionToDispatch', data.action)
      context.commit('setDataForAction', data.data)
    }
    document.getElementById('save-button').click()
  },

  async getMyCurrentUser({ commit }) {
    let response
    try {
      response = await getCurrentUser()
      commit('setCurrentUser', response.data)
      // TODO: WHY IS IT AN ARRAY ?
      commit('setCurrentUserPartyInDashboard', response.data[0].party)
      return response.data
    } catch (e) {
      console.log('getMyCurrentUser', e)
    }
  },

  async downloadStuff(context, { url, fileName }) {
    try {
      const downloaded = await fetch(url, { responseType: 'arraybuffer', exposedHeaders: ['Content-Disposition'] })
      const blob = new Blob([downloaded.data])
      const contentDisp = downloaded.request.getResponseHeader('Content-Disposition')

      const regex = /filename[^;=\n]*=(UTF-8(['"]*))?(.*)/
      const matches = regex.exec(contentDisp)

      if (matches != null && matches[3]) {
        fileName = matches[3].replace(/['"]/g, '')
      }
      const link = document.createElement('a')
      if (typeof link.download === 'undefined') {
        /**
         * [ie11 doesn't support download attribute. we use msSaveBlob instead]
         */
        if (navigator.msSaveBlob) {
          return navigator.msSaveBlob(blob, fileName)
        }
      }
      const download_url = window.URL.createObjectURL(blob)
      link.href = download_url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      link.parentNode.removeChild(link)
    } catch (e) {
      console.log('download error', e)
    }
  },

  async updateCurrentUser({ commit, dispatch }, { user, $gettext }) {
    try {
      await updateCurrentUser(user)
      await dispatch('getMyCurrentUser')
      commit('addAlertData', {
        displayMessage: $gettext('Saved'),
        variant: 'success'
      })
    } catch (e) {
      commit('addAlertData', {
        displayMessage: $gettext('Error'),
        variant: 'danger'
      })
      console.log('updateCurrentUser', e)
    }
  },

  async getCurrentUserForm(context) {
    const response = await getCurrentUser()
    context.commit('setCurrentUser', response.data)
  },

  async getMyCurrentSubmissions(context) {
    const response = await getSubmissions({
      filters: {
        currentState: 'data_entry'
        // party: context.state.currentUser.party
      },
      sorting: {
        sortDesc: true,
        sortBy: 'reporting_period'
      },
      perPage: null,
      currentPage: null
    })
    context.commit('setDashboardMySubmissions', response.data)
  },
  async getDashboardParties(context) {
    let response
    try {
      response = await getParties()
    } catch (e) {
      console.log(e)
      return
    }

    context.commit('setAllParties', response.data)

    const filtered_parties = response.data.filter(
      country => context.state.currentUser.related_parties.includes(country.id)
    ).map(
      country => ({ value: country.id, text: country.name, iso: country.abbr })
    )
    context.commit('setDashboardParties', filtered_parties)
    return filtered_parties
  },

  async getPeriods(context) {
    const periodsDisplay = {}

    const response = await getPeriods()
    response.data.forEach(period => {
      periodsDisplay[period.id] = period.name
    })

    context.commit('setDisplayPeriods', periodsDisplay)
  },

  async getDashboardPeriods(context) {
    const response = await getPeriods()
    let sortedPeriods = response.data
      .filter(a => a.is_reporting_allowed)
      .sort((a, b) => ((parseInt(b.end_date.split('-')[0]) - parseInt(a.end_date.split('-')[0])) === 0
        ? (parseInt(b.start_date.split('-')[0]) - parseInt(a.start_date.split('-')[0]))
        : (parseInt(b.end_date.split('-')[0]) - parseInt(a.end_date.split('-')[0]))))
      .sort((a, b) => b.is_year - a.is_year)
    sortedPeriods = sortedPeriods.map((period) => {
      const start = period.start_date.split('-')[0]
      const end = period.end_date.split('-')[0]
      let periodDisplay = ''
      if (start === end) {
        if (period.name !== start) {
          periodDisplay += `(${start})`
        }
      } else {
        periodDisplay += `(${start} - ${end})`
      }

      return {
        value: period.id,
        text: `${period.name} ${periodDisplay}`,
        end_date: period.end_date,
        start_date: period.start_date,
        description: period.description,
        is_default_period: period.is_default_period
      }
    })

    context.commit('setDashboardPeriods', sortedPeriods)
    return sortedPeriods
  },

  async getDashboardObligations(context) {
    const response = await getObligations()
    const obligations_temp = response.data.sort(
      (a, b) => parseInt(a.sort_order) > parseInt(b.sort_order)
    ).map(obligation => ({
      value: obligation.id,
      text: obligation.name,
      obligation_type: obligation.obligation_type,
      is_active: obligation.is_active
    }))
    context.commit('setDashboardObligations', obligations_temp)
  },

  setAlert(context, data) {
    Object.keys(data.message).forEach(key => {
      const message = escapeHTML(getMessage(data.message[key]))
      const labelValue = getLevel2PropertyValue(getLabels(data.$gettext), key)
      const displayMessage = `${labelValue ? `${labelValue}: ` : ''}${message}`
      context.commit('addAlertData', {
        displayMessage,
        variant: data.variant
      })
    })
  },

  async doSubmissionTransition({ dispatch }, { source, submission, transition, $gettext, noModal, backToDashboard = true, increment_minor = false }) {
    if (!noModal) {
      const confirmed = await dispatch('openConfirmModal', { $gettext })
      if (!confirmed) {
        return
      }
    }
    try {
      await callTransition(submission, transition, increment_minor)
      if (source === 'dashboard') {
        await dispatch('getCurrentSubmissions')
      } else {
        await dispatch('getSubmissionData', { submission, $gettext })
      }
      if (process.env.NODE_ENV !== 'development' && backToDashboard) {
        router.push({ path: '/dashboard' })
      }
      await dispatch('setAlert', {
        $gettext,
        message: { __all__: [$gettext('Submission status updated successfully.')] },
        variant: 'success'
      })
    } catch (error) {
      await dispatch('setAlert', {
        $gettext,
        message: { __all__: [$gettext('Unable to update submission status.')] },
        variant: 'danger'
      })
      console.log(error)
    }
  },

  async removeField({ dispatch, commit }, { tab, index, $gettext, noAlert }) {
    if (!noAlert) {
      const confirmed = await dispatch('openConfirmModal', { title: 'Please confirm', description: 'Are you sure you want to delete the selected row?', $gettext })
      if (!confirmed) {
        return confirmed
      }
    }
    commit('removeField', { tab, index })
  },

  async removeBulkFields({ dispatch, commit }, { tab, indexList, $gettext }) {
    const confirmed = await dispatch('openConfirmModal', { title: 'Please confirm', description: 'Are you sure you want to delete the selected rows?', $gettext })
    if (!confirmed) {
      return confirmed
    }
    commit('removeBulkFields', { tab, indexList })
  },

  async removeSubmission({ dispatch }, { submissionId, $gettext }) {
    const confirmed = await dispatch('openConfirmModal', { title: 'Please confirm', description: 'Are you sure you want to delete the submission? All data will be deleted irreversibly.', $gettext })
    if (!confirmed) {
      return confirmed
    }
    try {
      await deleteSubmission(submissionId)
      await dispatch('getCurrentSubmissions')
      await dispatch('setAlert', {
        $gettext,
        message: { __all__: [$gettext('Submission deleted successfully.')] },
        variant: 'success'
      })
    } catch (e) {
      await dispatch('getCurrentSubmissions')
      await dispatch('setAlert', {
        $gettext,
        message: { __all__: [$gettext('Unable to delete submission.')] },
        variant: 'danger'
      })
    }
    return confirmed
  },

  // CHECK THIS IF formName CHANGES. It's hardcoded for optimization purpose
  async getInitialData(context, { submission, formName, $gettext, additionalAction }) {
    context.commit('setForm', { formName, $gettext })
    console.log('----------------', formName)

    const [period, currentUser] = await Promise.allSettled([
      context.dispatch('getSubmissionData', { submission, $gettext }),
      context.dispatch('getCurrentUserForm')
    ])

    const promises = [
      context.dispatch('getCountries'),
      context.dispatch('getSubstances'),
      context.dispatch('getSubmissionDefaultValues'),
      context.dispatch('getReportingChannelOptions'),
      context.dispatch('getSubmissionFormatOptions'),
      context.dispatch('getCustomBlends')
    ]

    if (
      formName === 'art7'
      && ((Array.isArray(currentUser) && currentUser[0].is_secretariat)
      || (!Array.isArray(currentUser) && currentUser && currentUser.is_secretariat))
    ) {
      promises.push(context.dispatch('getEmailTemplates'))
    }

    if (formName === 'art7') {
      promises.push(
        context.dispatch('getControlledGroups', { party: context.state.current_submission.party, period }),
        context.dispatch('getNonParties', period)
      )
    }
    if (formName === 'essencrit' || formName === 'exemption') {
      promises.push(
        context.dispatch('getApprovedExemptionsList', { partyId: context.state.current_submission.party, period }),
        context.dispatch('getCriticalUseCategoryList'),
      )
    }
    if (formName === 'transfer') {
      promises.push(context.dispatch('getPeriods'))
    }
    if (additionalAction) {
      promises.push(context.dispatch(additionalAction))
    }
    await Promise.all(promises)
  },
  // party id, period name
  async getControlledGroups(context, { party, period }) {
    const controlledGroups = await getControlledGroups(party, period)
    context.commit('setControlledGroups', controlledGroups.data)
  },

  async getCriticalUseCategoryList(context) {
    const list = await getCriticalUseCategoryList()
    context.commit('setCriticalUseCategoryList', {
      data: list.data.map(cat => ({ text: cat.name, value: cat.id, code: cat.code })),
      display: list.data.reduce((result, item) => {
        result[item.id] = item.name
        return result
      }, {})
    })
  },

  async getEmailTemplates(context) {
    const templates = await getEmailTemplates()
    context.commit('setEmailTemplates', templates.data)
  },

  async getApprovedExemptionsList(context, { partyId, period }) {
    const exemptionsList = await getApprovedExemptionsList(partyId, period)
    context.commit('setApprovedExemptionsList', exemptionsList.data)
  },

  async getSubmissionFormatOptions(context) {
    const submissionFormatOptions = await getSubmissionFormats()
    context.commit('setSubmissionFormatOptions', submissionFormatOptions.data.map(s => ({ text: s.name, value: s.name })))
  },

  async getReportingChannelOptions(context) {
    const reportingChannelOptions = await getReportingChannels()
    context.commit('setReportingChannelOptions', reportingChannelOptions.data.map(s => ({ text: s.name, value: s.name })))
  },

  async getSubmissionData(context, { submission, $gettext }) {
    const response = await getSubmission(submission)
    await context.commit('updateSubmissionData', response.data)
    await context.commit('setFlagsPermissions', response.data.changeable_flags)
    await context.dispatch('getCurrentSubmissionHistory', { submission, $gettext })
    await context.commit('setFormPermissions', {
      permission_matrix: response.data.permission_matrix,
      edit_mode: router.app.$route.query.edit_mode === 'true' || router.app.$route.query.edit_mode === true || false
    })
    return response.data.reporting_period
  },

  async getCurrentSubmissionHistory(context, { submission, $gettext }) {
    try {
      const response = await getSubmissionHistory(submission)
      context.commit('setSubmissionHistory', response.data)
    } catch (error) {
      context.dispatch('setAlert', {
        $gettext,
        message: { ...error.response.data },
        variant: 'danger'
      })
    }
  },

  async getPartyRatifications(context) {
    const response = await getPartyRatifications()
    context.commit('updatePartyRatifications', response.data)
  },

  async getReportsList() {
    const reports = await getReports()
    return reports.data.map(r => ({ value: r.name, text: r.display_name, original: r }))
  },

  // getReportingChannel(context) {
  //   getReportingChannel().then(response => {
  //     const reportingChannel = response.data.map(channel => ({ text: channel.name, value: channel.name, is_secretariat: channel.is_secretariat, is_party: channel.is_party }))
  //     context.commit('updateReportingChannel', reportingChannel)
  //   })
  // },

  async getCountries(context) {
    const countryDisplay = {}
    const response = await getParties()
    const countryOptions = response.data.map((country) => {
      countryDisplay[country.id] = country.name
      countryDisplay['other'] = 'other'
      return { value: country.id, text: country.name, iso: country.abbr }
    }).filter((p) => p.value !== context.state.current_submission.party)
    const countryOptionsSubInfo = response.data.map((country) => ({ value: country.id, text: country.name, iso: country.abbr }))
    context.commit('updateCountries', countryOptions)
    context.commit('updateCountriesDisplay', countryDisplay)
    context.commit('updateCountriesSubInfo', countryOptionsSubInfo)
  },

  async getSubstances(context) {
    const tempSubstances = []
    const substancesDisplay = {}
    const response = await getSubstances()
    response.data.forEach(group => {
      group.substances.sort((a, b) => a.sort_order - b.sort_order)
      group.substances.forEach(substance => {
        tempSubstances.push({
          value: substance.id,
          text: substance.name,
          group,
          is_qps: substance.is_qps,
          is_contained_in_polyols: substance.is_contained_in_polyols,
          is_captured: substance.is_captured,
          has_critical_uses: substance.has_critical_uses
        })
        substancesDisplay[substance.id] = substance.name
      })
    })

    await context.commit('updateGroupSubstances', response.data)
    await context.commit('updateSubstances', tempSubstances)
    await context.commit('updateSubstancesDisplay', substancesDisplay)
  },

  async getCustomBlends(context) {
    const blendsDisplay = {}
    const response = await getCustomBlends()
    response.data.forEach(blend => {
      blend.components.sort((component1, component2) => component2.percentage - component1.percentage)
      blendsDisplay[blend.id] = { name: blend.blend_id, components: blend.components, is_qps: blend.is_qps }
    })
    context.commit('updateBlends', response.data)
    context.commit('updateBlendsDisplay', blendsDisplay)
  },

  async getNonParties(context, reporting_period) {
    const response = await getNonParties(reporting_period)
    context.commit('updateNonParties', response.data)
  },

  createSubstance(context, data) {
    const substancesHere = data.substanceList && data.substanceList.some((el) => el !== null)
    const blendsHere = data.blendList && data.blendList.some((el) => el !== null)
    if (substancesHere) {
      data.substanceList.forEach(substance => {
        const inner_fields = context.state.tableRowConstructor.substanceRows({
          $gettext: data.$gettext,
          section: data.currentSectionName,
          substance,
          group: data.groupName,
          country: data.country,
          blend: null,
          prefillData: data.prefillData,
          countries: context.state.initialData.display.countries,
          critical: data.critical || null,
          exemptionValue: data.exemptionValue,
          critical_use_categories: context.state.initialData.display.criticalUseCategoryList,
          has_critical_uses: context.getters.getCriticalSubstances(substance, data.substanceList),
          is_captured: context.getters.getCapturedSubstance(substance, data.substanceList)
        })
        context.commit('addRow', { sectionName: data.currentSectionName, row: inner_fields })
      })
    } else if (blendsHere) {
      data.blendList.forEach(blend => {
        // let ordering_id = 0
        // if (!data.prefillData) {
        //   context.commit('incrementOrderingId', { tabName: data.currentSectionName });
        //   ({ ordering_id } = context.state.form.tabs[data.currentSectionName].ordering_id)
        // }
        const inner_fields = context.state.tableRowConstructor.substanceRows({
          $gettext: data.$gettext,
          section: data.currentSectionName,
          substance: null,
          group: data.groupName,
          country: data.country,
          blend,
          prefillData: data.prefillData
          // ordering_id
        })
        context.commit('addRow', { sectionName: data.currentSectionName, row: inner_fields })
      })
    }
  },

  createRow(context, { currentSectionName, prefillData, $gettext }) {
    let ordering_id = 0
    if (!prefillData) {
      context.commit('incrementOrderingId', { tabName: currentSectionName });
      ({ ordering_id } = context.state.form.tabs[currentSectionName])
    }

    const row = context.state.tableRowConstructor.nonSubstanceRows({
      $gettext,
      currentSectionName,
      prefillData,
      ordering_id
    })
    context.commit('addRow', { sectionName: currentSectionName, row })
  },

  clearEdited({ state, commit }) {
    Object.keys(state.form.tabs).filter(tab => state.form.tabs[tab].status === 'edited').forEach((tab) => {
      commit('setTabStatus', { tab, value: null })
    })
  },

  removeDataFromTab(context, data) {
    context.commit('resetTab', data)
  },
  async uploadFiles(context, { files, onProgressCallback }) {
    for (let i = 0; i < files.length; i += 1) {
      const file = files[i]
      const response = await uploadFile(file, context.state.current_submission.id, onProgressCallback)
      file.tus_url = response.url
      file.percentage = 100
    }
  },

  async getNewTransitions({ state, commit }) {
    const transitions = await getTransitions(state.current_submission.available_transitions_url)
    console.log(transitions)
    commit('updateTransitions', transitions.data[0].available_transitions)
  },

  async getSubmissionFiles(context) {
    const response = await getSubmissionFiles(context.state.current_submission.id)
    return response.data
  },
  async deleteTabFile({ state, commit }, { file }) {
    console.log(file)
    if (file.tus_id) {
      await deleteSubmissionFile({ file, submissionId: state.current_submission.id })
    }

    commit('deleteTabFile', { file })
  },
  updateLocalFilesFromServerFilesResponse({ state, commit }, { filesOnServer }) {
    const { form_fields } = state.form.tabs.files
    const filesLocal = form_fields.files
    filesOnServer.forEach(fileServerInfo => {
      const fileJustUploaded = filesLocal.find(x => {
        if (x.tus_id) {
          return x.tus_id === fileServerInfo.tus_id
        }
        return x.tus_url && x.tus_url.endsWith(fileServerInfo.tus_id)
      })
      console.log(fileJustUploaded)
      if (fileJustUploaded) {
        commit('updateTabFileWithServerInfo', {
          file: fileJustUploaded,
          fileServerInfo
        })
      }
    })
  },
  async setJustUploadedFilesState({ dispatch }) {
    const filesOnServer = await dispatch('getSubmissionFiles')
    await dispatch('updateLocalFilesFromServerFilesResponse', {	filesOnServer })
  },
  async getSubmissionDefaultValues({ commit }) {
    const response = await getSubmissionDefaultValues()
    commit('setSubmissionDefaultValues', response.data)
    return response.data || {}
  },
  async fetchSubmissionStates({ commit }) {
    const response = await getSubmissionStates()
    commit('setSubmissionStates', response.data)
    return response.data || {}
  }
}

export default actions
